var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 23.002V8.00195M20.75 0.501953V5.50195V0.501953ZM20.75 23.002V10.502V23.002ZM12 0.501953V15.502V0.501953ZM12 23.002V20.502V23.002ZM3.25 0.501953V3.00195V0.501953Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 8.00195C18.25 9.38267 19.3693 10.502 20.75 10.502C22.1307 10.502 23.25 9.38267 23.25 8.00195C23.25 6.62124 22.1307 5.50195 20.75 5.50195C19.3693 5.50195 18.25 6.62124 18.25 8.00195Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.002C9.5 19.3827 10.6193 20.502 12 20.502C13.3807 20.502 14.5 19.3827 14.5 18.002C14.5 16.6212 13.3807 15.502 12 15.502C10.6193 15.502 9.5 16.6212 9.5 18.002Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.749999 5.50195C0.749999 6.88267 1.86929 8.00195 3.25 8.00195C4.63071 8.00195 5.75 6.88267 5.75 5.50195C5.75 4.12124 4.63071 3.00195 3.25 3.00195C1.86929 3.00195 0.749999 4.12124 0.749999 5.50195Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.b163dae2ec2c9fd7460ad394e1a6c718.svg";
export { ForwardRef as ReactComponent };